import HLS from 'hls.js';

export const getHLSVideoElement = (url: string, autoplay: boolean, playLowestQuality: boolean = false) => {
  const videoElement = document.createElement('video');

  videoElement.controls = true;
  videoElement.autoplay = autoplay;
  videoElement.muted = autoplay;

  if (HLS.isSupported()) {
    const hlsConfig: any = {};

    if (playLowestQuality) {
      // Minimal configuration for fast preview playback
      Object.assign(hlsConfig, {
        backBufferLength: 2, // Minimal back buffer for previews
        maxBufferLength: 2, // Very small buffer for previews
        maxMaxBufferLength: 2,
        maxBufferSize: 500 * 1024, // 500KB buffer for previews
        maxBufferHole: 0.1, // Very small buffer hole tolerance
        lowLatencyMode: true,
        // Additional optimizations for fast startup
        maxFragLookUpTolerance: 0.1,
        liveSyncDurationCount: 1,
        liveMaxLatencyDurationCount: 2,
        // Reduce manifest loading time - no retries for faster failure
        manifestLoadingTimeOut: 3000, // 3 seconds timeout
        manifestLoadingMaxRetry: 0, // No retries
        levelLoadingTimeOut: 3000,
        levelLoadingMaxRetry: 0, // No retries
        fragLoadingTimeOut: 3000,
        fragLoadingMaxRetry: 0, // No retries
        // Disable features that slow down startup
        enableWorker: false, // Disable web worker for faster startup
        enableSoftwareAES: false, // Disable software AES decryption
        // Reduce bandwidth estimation time
        abrEwmaFastLive: 1,
        abrEwmaSlowLive: 1,
        abrEwmaFastVoD: 1,
        abrEwmaSlowVoD: 1,
        // Conservative bandwidth estimation
        abrBandWidthFactor: 0.5, // Assume 50% of actual bandwidth
        abrBandWidthUpFactor: 0.5 // Conservative bandwidth estimation
      });
    } else {
      // Use HLS.js defaults for normal playback
      hlsConfig.backBufferLength = 30;
    }

    const hls = new HLS(hlsConfig);
    hls.attachMedia(videoElement);

    hls.on(HLS.Events.MEDIA_ATTACHED, () => {
      hls.loadSource(url);
      hls.on(HLS.Events.MANIFEST_PARSED, (event: any, data: any) => {
        if (playLowestQuality && data.levels && data.levels.length > 0) {
          // HLS.js levels are ordered from lowest (0) to highest (length-1)
          const lowestLevel = 0; // Level 0 is the lowest quality
          hls.currentLevel = lowestLevel;
          // Disable auto level switching by setting nextLevel to the same level
          hls.nextLevel = lowestLevel;
        }

        if (autoplay) {
          videoElement.play();
        }
      });
    });

    hls.on(HLS.Events.ERROR, (event: any, data: any) => {
      if (videoElement.onerror) {
        videoElement.onerror(data);
      }
    });
  } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
    videoElement.src = url;
    videoElement.setAttribute('playsinline', '');
  } else {
    throw new Error('HLS Playback is not supported on this device!');
  }
  return videoElement;
};
